// extracted by mini-css-extract-plugin
module.exports = {"remote":"Remote__remote__3Sutz layout__fill__1rDTs","chat":"Remote__chat__1RdOI","users":"Remote__users__kTgb6"};